import { render, staticRenderFns } from "./cricketLayout.vue?vue&type=template&id=7ff203f8&"
import script from "./cricketLayout.vue?vue&type=script&lang=js&"
export * from "./cricketLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports